import script from "./fileUpload1.vue?vue&type=script&setup=true&lang=js"
export * from "./fileUpload1.vue?vue&type=script&setup=true&lang=js"

import "./fileUpload1.vue?vue&type=style&index=0&id=4bf0d3ec&lang=scss"

const __exports__ = script;

export default __exports__